'use strict';

import $ from 'jquery';
import Analytics from '../../../assets/components/Analytics/Analytics';
import { EnableAdobeAnalytics } from '../../../assets/utilities/featureFlags';

var _ = require('underscore'),
  CarouselBaseView = require('./CarouselBaseView'),
  utilities = require('../../js/utilities'),
  CarouselView;

CarouselView = CarouselBaseView.extend({
  options: {
    pagination: false,
    slideClass: '.CarouselModule-slide',
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: false,
    autoplay: false,
    prevArrow: '<button aria-label="Related news articles previous" class="CarouselModule-prev Icon Icon--circle Icon--out"/>',
    nextArrow: '<button aria-label="Related news articles next" class="CarouselModule-next Icon Icon--circle Icon--play"/>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  },

  get events() {
    return {
      'click .related-articles-img-link': 'pushInformationToAdobe',
      'click .CarouselModule-slide-heading a': 'pushInformationToAdobe',
    };
  },

  initialize: function(options) {

    if (utilities._isMobileOrTabletDevice()) {
      options.autoplay = false;
      if (CarouselView.__super__.options) {
        CarouselView.__super__.options.autoplay = false;
      }
      if (this.options) {
        this.options.autoplay = false;
      }
    }

    this.options = _.defaults(this.options, CarouselView.__super__.options);
    CarouselView.__super__.initialize.call(this, options);
    if ('.related-articles-img-link') {
      $('.related-articles-img-link').attr('tabindex','-1');
    }
  },

  pushInformationToAdobe(e) {
    e.preventDefault()
    if (EnableAdobeAnalytics.isEnabled()) {
      let tags = [];
      let $parentElement = $(e.currentTarget.parentElement.parentElement);
      if (e.currentTarget.className === 'related-articles-img-link') {
        $parentElement = $(e.currentTarget.parentElement.parentElement);
      } else {
        $parentElement = $(e.currentTarget.parentElement.parentElement.parentElement);
      }
      let articleTitle = $parentElement.find('.CarouselModule-slide-heading a').text();
      $($parentElement).find('.Tags-item-text').each(function() {
        tags.push($(this).text().trim());
      });
      const adobeData = {
        event: 'article_interaction',
        articleTitle: articleTitle.trim() || undefined,
        article: articleTitle,
        articleTags: tags
      }
      Analytics.setOnAdobeDataLayer(adobeData);
    }
    const href = $(e.currentTarget).attr('href');
    window.location.href = href;
  }

}, {
  create: function($parent) {
    $parent.find('.CarouselModule').each(function(n, el) {
      new CarouselView({
        el: el
      });
    });
  }
});

module.exports = CarouselView;



// WEBPACK FOOTER //
// ./assets/components/Carousel/CarouselView.js